import { Auth, RegistrationDetails } from '@util/Auth';
import { AuthValidation } from '@util/AuthValidation';
import { addUserToAvailableHcpReferral } from '../../../helpers/HcpReferrals';
import { ActionType } from '../../ActionTypes';
import { AppSelector, store as baseStore } from '../../Store';
import { prepareUserDataForPersistence } from '../../userData/PrepareUserDataForPersistence';
import { handleUserError, surveyCompletedAction, validateUserIsNotAuthenticated } from '../Utils';

export type RegistrationNewUserDetails = RegistrationDetails & {
  confirmEmail: string;
};

/** Registers a user and updates the user state with the result. */
export async function registerUser(
  details: RegistrationNewUserDetails,
  store = baseStore
): Promise<void> {
  try {
    store.dispatch({ type: ActionType.REGISTER_USER_LOADING });

    validateUserIsNotAuthenticated();

    AuthValidation.validateRegistration(details);

    const userData = prepareUserDataForPersistence(AppSelector.userData(store.getState()));

    const { user, paid: hasPaid } = await Auth.signUpAndRegisterForPayment({
      ...details,
      userData,
    });

    store.dispatch({
      type: ActionType.REGISTER_USER_SUCCESS,
      user: { ...user, setUserPassword: false, hasPaid },
    });

    store.dispatch(surveyCompletedAction());

    await addUserToAvailableHcpReferral();
  } catch (rawError) {
    const error = handleUserError(rawError);
    store.dispatch({ type: ActionType.REGISTER_USER_FAILURE, error });
  }
}
